import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import { put, post } from 'helpers/apiHelpers';
import DataGrid from 'components/DataGrid/DataGrid';
import EditIcon from '@material-ui/icons/Edit';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Close from '@material-ui/icons/Close';
import FormLabel from '@material-ui/core/FormLabel';
import { fetchLanguages } from 'actions/Auth';
// eslint-disable-next-line import/order -- FIXME
import { toast } from 'react-toastify';

// eslint-disable-next-line import/order -- FIXME
import LabeledCheckbox from 'components/Checkbox/LabeledCheckbox';
import { orderStyles } from '../Orders/styles';
import ModalButton from '../../components/CustomButtons/Button';
import FormControlButtons from '../../components/FormControlButtons/FormControlButtons';
import CustomInput from '../../components/CustomInput/CustomInput';
import { DialogLoader } from '../../components/DialogLoader';
// eslint-disable-next-line import/order -- FIXME
import I18NSection from '../Brands/I18nSection';

import SelectInput from '../../components/FormSelect/SelectInput';
// eslint-disable-next-line import/order -- FIXME
import FormImageUpload from '../../components/FormImageUpload/FormImageUpload';

import { setMultinational } from '../../actions/Brands';

// eslint-disable-next-line import/order -- FIXME
import { Info } from '@material-ui/icons';
// eslint-disable-next-line import/order -- FIXME
import Tooltip from '@material-ui/core/Tooltip';
// eslint-disable-next-line import/order -- FIXME
import { makeStyles } from '@material-ui/styles';
// eslint-disable-next-line import/order -- FIXME
import { grayColor } from 'assets/jss/material-dashboard-pro-react';

import { ROLE_IMPERSONATE_USER } from '../../helpers/roles';
import getColumnConfig from './getColumnConfig';
import FormSelectSingle from '../../components/FormSelect/FormSelectSingle';
import extendedFormsStyle from '../../assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import { isGranted } from '../../helpers/helpers';

const useStyles = makeStyles({
  wrapper: { padding: '40px' },
  labelHorizontal: extendedFormsStyle.labelHorizontal,
  languageConfigSection: {
    marginTop: '15px',
  },
  infoIcon: {
    color: grayColor[0],
  },
  gridItem: {
    display: 'flex',
    alignItems: 'center',
    margin: '0',
  },
  labeledCheckbox: {
    marginRight: '5px',
  },
  imageUploadContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  imageUploadWrapper: {
    maxWidth: 300,
    width: '100%',
  },
});

const defaultModalData = {
  isoCode: '',
  name: '',
  enabledForAdmin: false,
  enabledForClient: false,
  copyFromLanguage: null,
  image: null,
};

const LanguageSettings = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const languagesFromRedux = useSelector(state => state.Auth.languages);
  const selectedBrand = useSelector(state => state.Auth.selectedBrand);
  const multinational = useSelector(state => state.Brands.brand?.multinational);

  const [languages, setLanguages] = useState(null);
  const [defaultLanguage, setDefaultLanguage] = useState(
    multinational?.defaultLanguage || null
  );
  const [clientAllowedToChangeLanguage, setClientAllowedToChangeLanguage] =
    useState(multinational?.clientAllowedToChangeLanguage || false);

  const [adminDefaultLanguage, setAdminDefaultLanguage] = useState(
    multinational?.adminDefaultLanguage || null
  );
  const [adminAllowedToChangeLanguage, setAdminAllowedToChangeLanguage] =
    useState(multinational?.adminAllowedToChangeLanguage || false);

  const [supportedRegions, setSupportedRegions] = useState(
    multinational?.supportedRegions || null
  );
  const [currency, setCurrency] = useState(multinational?.currency || null);
  const [salesMarket] = useState(multinational?.salesMarket || null);
  const [isModalOpened, setIsModalOpened] = useState(false);
  const [modalData, setModalData] = useState(defaultModalData);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [modalImageUrl, setModalImageUrl] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [canRemoveLanguages, setCanRemoveLanguages] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    dispatch(fetchLanguages()).finally(() => setIsLoading(false));
  }, [dispatch]);

  useEffect(() => {
    if (languagesFromRedux && Array.isArray(languagesFromRedux)) {
      setLanguages(languagesFromRedux);
    }
  }, [languagesFromRedux]);

  const handleSubmitLanguage = async () => {
    const payload = {
      ...modalData,
      image:
        modalData.image &&
        typeof modalData.image === 'object' &&
        modalData.image['@id']
          ? modalData.image['@id']
          : modalData.image,
    };

    try {
      setRefresh(true);
      setIsLoading(true);
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- FIXME
      modalData?.id
        ? await put(`/languages/${modalData.id}`, payload)
        : await post('/languages', payload);
      await dispatch(fetchLanguages());
      toast.success(t('success.changesSaved'));
      // eslint-disable-next-line @typescript-eslint/no-unused-vars -- FIXME
    } catch (e) {
      toast.error(t('notify.cannotSave'));
    } finally {
      setIsLoading(false);
      setRefresh(false);
      // eslint-disable-next-line no-use-before-define -- FIXME
      closeModal();
    }
  };

  const handleSubmit = async () => {
    try {
      setIsSubmitting(true);
      const response = await put(`/brands/${selectedBrand}`, {
        multinational: {
          adminAllowedToChangeLanguage,
          adminDefaultLanguage,
          clientAllowedToChangeLanguage,
          defaultLanguage,
          supportedRegions,
          currency,
          salesMarket,
        },
      });

      toast.success(t('success.changesSaved'));

      dispatch(setMultinational(response.multinational));
      // eslint-disable-next-line @typescript-eslint/no-unused-vars -- FIXME
    } catch (e) {
      toast.error(t('notify.cannotSave'));
    } finally {
      setIsSubmitting(false);
    }
  };

  const customActions = () => [
    {
      action: props => {
        setIsEdit(true);
        setIsModalOpened(true);
        setModalData(props.row);
        setModalImageUrl(props.row.image?.contentUrl || null);
      },
      icon: <EditIcon />,
      disabled: !isGranted(ROLE_IMPERSONATE_USER),
      color: 'warning',
      buttonText: null,
      simple: true,
      round: true,
      justIcon: true,
    },
  ];

  const setImage = (_, data) => {
    setModalData(prevState => ({
      ...prevState,
      image: data?.['@id'] || null,
    }));
    setModalImageUrl(data?.contentUrl || null);
  };

  const removeImage = () => {
    setModalData(prevState => ({
      ...prevState,
      image: null,
    }));
    setModalImageUrl(null);
  };

  const closeModal = () => {
    setIsModalOpened(false);
    setModalData(defaultModalData);
    setModalImageUrl(null);
  };

  return (
    <>
      <DialogLoader
        loaderState={isLoading || !languages}
        text={t('common.loading')}
      />
      <DialogLoader loaderState={isSubmitting} text={t('form.savingChanges')} />
      <Dialog
        open={isModalOpened}
        onClose={closeModal}
        maxWidth="sm"
        fullWidth={true}
      >
        <DialogContent className={classes.wrapper}>
          <ModalButton
            style={orderStyles.closeButton}
            color="transparent"
            justIcon={true}
            round={true}
            onClick={closeModal}
          >
            <Close />
          </ModalButton>
          <FormLabel className={classes.labelHorizontal}>
            {t('languageSettings.languageName')}
          </FormLabel>
          <CustomInput
            formControlProps={{ fullWidth: true }}
            inputProps={{
              type: 'text',
              name: 'name',
              value: modalData.name,
              onChange: e =>
                setModalData(prevState => ({
                  ...prevState,
                  name: e.target.value,
                })),
            }}
          />
          {!isEdit && (
            <>
              <FormLabel className={classes.labelHorizontal}>
                {t('languageSettings.languageNameShort')}
              </FormLabel>
              <CustomInput
                formControlProps={{ fullWidth: true }}
                inputProps={{
                  type: 'text',
                  name: 'isoCode',
                  value: modalData.isoCode,
                  onChange: e =>
                    setModalData(prevState => ({
                      ...prevState,
                      isoCode: e.target.value,
                    })),
                }}
              />
              <FormSelectSingle
                options={languages}
                mapBy="name"
                trackBy="@id"
                value={modalData.copyFromLanguage}
                handleChange={e => {
                  setModalData(prevState => ({
                    ...prevState,
                    copyFromLanguage: e.target.value,
                  }));
                }}
                label={t('languageSettings.downloadTranslationsFrom')}
              />
            </>
          )}
          <GridContainer xs={12} className={classes.imageUploadContainer}>
            <GridItem className={classes.imageUploadWrapper}>
              <FormImageUpload
                stateName="flagImage"
                buttonText={t('brandCfg.selectIcon')}
                getImage={setImage}
                removeImage={removeImage}
                previewUrl={modalImageUrl}
              />
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} className={classes.gridItem}>
              <LabeledCheckbox
                className={classes.labeledCheckbox}
                name="enabledForAdmin"
                label={t('languageSettings.enabledForAdmin')}
                checked={modalData.enabledForAdmin}
                onChange={e =>
                  setModalData(prevState => ({
                    ...prevState,
                    enabledForAdmin: e.target.checked,
                  }))
                }
              />
              <Tooltip
                className={classes.tooltip}
                title={t('languageSettings.enabledForAdmin.tooltip')}
              >
                <Info className={classes.infoIcon} fontSize="small" />
              </Tooltip>
            </GridItem>
            <GridItem xs={12} className={classes.gridItem}>
              <LabeledCheckbox
                className={classes.labeledCheckbox}
                name="enabledForClient"
                label={t('languageSettings.enabledForClient')}
                checked={modalData.enabledForClient}
                onChange={e =>
                  setModalData(prevState => ({
                    ...prevState,
                    enabledForClient: e.target.checked,
                  }))
                }
              />
              <Tooltip
                className={classes.tooltip}
                title={t('languageSettings.enabledForClient.tooltip')}
              >
                <Info className={classes.infoIcon} fontSize="small" />
              </Tooltip>
            </GridItem>
          </GridContainer>
          <FormControlButtons
            submitText={t('zoneCategories.save')}
            handleSubmit={handleSubmitLanguage}
          />
        </DialogContent>
      </Dialog>
      <GridContainer className={classes.languageConfigSection}>
        <GridItem xs={12}>
          <Card>
            <CardBody>
              <GridContainer>
                <GridItem md={6}>
                  <h3>{t('common.clientPanel')}</h3>
                  <FormSelectSingle
                    options={
                      languages?.filter(lang => lang.enabledForClient) || []
                    }
                    mapBy="name"
                    trackBy="isoCode"
                    value={defaultLanguage}
                    handleChange={e => {
                      setDefaultLanguage(e.target.value);
                    }}
                    label={t('$*multinational.defaultLanguage')}
                  />
                  <LabeledCheckbox
                    className={classes.labeledCheckbox}
                    name="clientCanChangeLanguage"
                    label={t('languageSettings.clientAllowedToChangeLanguage')}
                    checked={clientAllowedToChangeLanguage}
                    onChange={e =>
                      setClientAllowedToChangeLanguage(e.target.checked)
                    }
                  />
                </GridItem>

                <GridItem md={6}>
                  <h3>{t('common.adminPanel')}</h3>
                  <FormSelectSingle
                    options={
                      languages?.filter(lang => lang.enabledForAdmin) || []
                    }
                    mapBy="name"
                    trackBy="isoCode"
                    value={adminDefaultLanguage}
                    handleChange={e => {
                      setAdminDefaultLanguage(e.target.value);
                    }}
                    label={t('$*multinational.defaultLanguage')}
                  />

                  <LabeledCheckbox
                    className={classes.labeledCheckbox}
                    name="adminCanChangeLanguage"
                    label={t('languageSettings.adminCanChangeLanguage')}
                    checked={adminAllowedToChangeLanguage}
                    onChange={e =>
                      setAdminAllowedToChangeLanguage(e.target.checked)
                    }
                  />
                </GridItem>

                <GridItem md={6}>
                  <h3>{t('brandCfg.i18n')}</h3>
                  <I18NSection
                    setSupportedRegions={e => setSupportedRegions([e])}
                    supportedRegions={supportedRegions}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem md={6}>
                  <FormLabel className={classes.labelHorizontal}>
                    {t('brandCfg.brandCurrency')}
                  </FormLabel>
                  <SelectInput
                    noGrid={true}
                    mapBy="label"
                    trackBy="value"
                    name="multinational.currency"
                    value={currency}
                    options={[
                      {
                        label: t('languageSettings.brandCurrency.option.pln'),
                        value: 'PLN',
                      },
                      {
                        label: t('languageSettings.brandCurrency.option.eur'),
                        value: 'EUR',
                      },
                      {
                        label: t('languageSettings.brandCurrency.option.gbp'),
                        value: 'GBP',
                      },
                      {
                        label: t('languageSettings.brandCurrency.option.usd'),
                        value: 'USD',
                      },
                      {
                        label: t('languageSettings.brandCurrency.option.czk'),
                        value: 'CZK',
                      },
                      {
                        label: t('languageSettings.brandCurrency.option.nok'),
                        value: 'NOK',
                      },
                      {
                        label: t('languageSettings.brandCurrency.option.chf'),
                        value: 'CHF',
                      },
                    ]}
                    disabled={false}
                    handleChange={e => setCurrency(e.target.value)}
                    size={12}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem sm={12}>
                  <FormControlButtons
                    submitText={t('common.shared.save')}
                    handleSubmit={handleSubmit}
                  />
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardBody>
              <GridContainer>
                <GridItem md={12}>
                  <FormControlButtons
                    handleSubmit={() => {
                      setIsEdit(false);
                      setIsModalOpened(true);
                    }}
                    submitText={`${t('languageSettings.addLanguage')} +`}
                  />
                  <DataGrid
                    actions={true}
                    paginationTop={false}
                    paginationBottom={false}
                    url="/languages"
                    reportName="languages"
                    columns={getColumnConfig()}
                    customActions={customActions}
                    remove={true}
                    disableTotal={true}
                    refresh={refresh}
                    hideArchive={true}
                    onFetchedData={response => {
                      setCanRemoveLanguages(response.length > 1);
                    }}
                    canRemoveChecker={(_, row) =>
                      canRemoveLanguages && row.isoCode !== adminDefaultLanguage
                    }
                  />
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </>
  );
};

export default LanguageSettings;
